import styled, { css } from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import { themeGet } from '@styled-system/theme-get'

import { motion } from 'framer-motion'

import { TRANSITION } from 'Constants/Animations'

type StyledButtonProps = {
  iconRotated?: boolean
}

export const ControlButton = styled.button`
  color: ${themeGet('colors.primary.main')};
`

export const Container = styled(motion.div)<PaddingProps>`
  position: fixed;
  top: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  overflow: hidden;
  height: 100dvh;
  background-color: ${themeGet('colors.background.screen')};

  ${padding}
`

export const NavButton = styled.button`
  display: flex;
  width: 100%;
  padding: ${themeGet('space.5')}px;
`

const styledButtonIconRotatedCss = ({ iconRotated }: StyledButtonProps) =>
  iconRotated &&
  css`
    > svg {
      transform: rotateZ(180deg);
    }
  `

const shouldForwardProp = (prop: string) => !['iconRotated'].includes(prop)

export const StyledButton = styled.button.withConfig({
  shouldForwardProp,
})<StyledButtonProps>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${themeGet('space.3')}px;
  padding: ${themeGet('space.5')}px;
  width: 100%;

  > svg {
    transition: all ${TRANSITION.DEFAULT.duration}s;
    transform: rotateZ(0deg);
  }

  ${styledButtonIconRotatedCss}
`

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${themeGet('colors.border.link')};
`

export const Overflow = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100dvw;
  height: 100dvh;
  pointer-events: none;
  background-color: ${themeGet('colors.overlay.default')};
`
